import React from 'react';
import { Button } from 'components/core';

interface Props {
  label: string;
  permitted: boolean;
  status: string;
  url: string;
}

const ExtractionStatusAction = ({ label, permitted, status, url }: Props) => {
  const type = status == 'complete' ? 'success' : 'brand';
  const variant = status == 'not-started' ? 'solid' : 'outline';

  return permitted ? (
    <Button
      type={type}
      variant={variant}
      to={url}
      className="DEStudyListAction"
    >
      {label}
    </Button>
  ) : (
    <div className="DEStudyListAction">{label}</div>
  );
};

export default ExtractionStatusAction;
